import { actions } from "../shared/constants"

export const createHostAction = (type, data) => {
  return {
    type: actions.HOST_ACTION,
    data: {
      type,
      data,
    },
  }
}
